import * as React from 'react'

export const Cohorts = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24.64 22.73'
    xmlSpace='preserve'
    width="1em" height="1em" fill="currentColor"
  >
    <path d='M22.54 20.92c-.16.34-.43.44-.8.44-1.48-.01-2.96-.01-4.44-.01-.48 0-.71-.23-.71-.7v-4.56c0-.46.23-.69.7-.69h1.67v-2.8H13v2.8c.58 0 1.15-.01 1.72.01.15 0 .34.06.44.17.11.11.19.3.19.45.01 1.56.01 3.13.01 4.69 0 .37-.25.62-.62.62h-4.69c-.37 0-.62-.25-.62-.62v-4.69c0-.37.25-.62.62-.62h1.74v-2.8H5.83v2.8h1.71c.41 0 .65.24.65.65v4.63c0 .41-.24.66-.65.66H2.91c-.41 0-.66-.24-.66-.65v-4.63c0-.42.24-.66.67-.66h1.71V12.1c0-.46.23-.69.69-.69h6.46V8.6h-2.4c-.55 0-.76-.21-.76-.77 0-1.99.01-3.97-.01-5.96 0-.37.1-.64.44-.8h6.66c.34.16.44.43.44.8-.01 2.01-.01 4.03-.01 6.04 0 .46-.23.69-.69.69h-2.46v2.81h6.48c.45 0 .68.23.68.68v3.32c.54 0 1.06.02 1.58-.01.37-.01.64.1.8.44.01 1.7.01 3.39.01 5.08zM14.96 2.27H9.83V7.4h5.13V2.27zM7 20.16v-3.54H3.46v3.54H7zm3.62-.01h3.54v-3.54h-3.54v3.54zm7.17 0h3.54v-3.54h-3.54v3.54z' />
  </svg>
)
